export default {
  nameWarehouse: 'ชื่อคลังสินค้า',
  address: 'ที่อยู่',
  phone: 'เบอร์โทรศัพท์',
  detail: 'รายละเอียด'
};
